export default __webpack_public_path__ + "static/media/appLogo.ca5bcd49.svg";